<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="4" rounded="lg">
        <!-- Header -->
        <v-card-title class="py-3 px-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-btn icon small @click="$router.push('/coupons')" class="mr-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <div>
              <h2 class="text-h6 font-weight-bold">Coupon Usage Report</h2>
              <p class="text-caption grey--text mb-0">Orders where coupons were applied</p>
            </div>
          </div>
          <v-chip color="primary" small>{{ count }} orders</v-chip>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Filters -->
        <v-card-subtitle class="pb-2 pt-3 px-4">
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="filter.search_keyword"
                label="Search by Order ID"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                clearable
                hide-details
                @input="(page = 1), getData()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filter.coupon_id"
                :items="couponOptions"
                item-text="text"
                item-value="value"
                label="Filter by Coupon"
                prepend-inner-icon="mdi-ticket-percent"
                outlined
                dense
                clearable
                hide-details
                @change="(page = 1), getData()"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-subtitle>

        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="orders"
          :loading="isLoading"
          :items-per-page="rowsPerPage"
          hide-default-footer
          class="elevation-0"
        >
          <template #[`item.coupon_discount`]="{ item }">
            <span class="success--text font-weight-medium">
              - ₹{{ item.coupon_discount | toFixed2 }}
            </span>
          </template>
          <template #[`item.order_total`]="{ item }">
            ₹{{ item.order_total | toFixed2 }}
          </template>
          <template #[`item.order_status`]="{ item }">
            <v-chip x-small :color="statusColor(item.order_status)">
              {{ item.order_status }}
            </v-chip>
          </template>
        </v-data-table>

        <!-- Pagination -->
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-2 d-flex justify-end">
          <v-pagination
            v-model="page"
            :length="paginationLength"
            total-visible="7"
            @input="getData"
          ></v-pagination>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
export default {
  name: "CouponUsageReport",
  filters: {
    toFixed2(val) {
      return parseFloat(val || 0).toFixed(2);
    },
  },
  data() {
    return {
      isLoading: false,
      orders: [],
      count: 0,
      page: 1,
      rowsPerPage: 15,
      paginationLength: 0,
      couponOptions: [],
      filter: {
        search_keyword: "",
        coupon_id: null,
      },
      headers: [
        { text: "#", value: "index", width: "50px" },
        { text: "Order ID", value: "order_id" },
        { text: "Date", value: "order_date" },
        { text: "Status", value: "order_status" },
        { text: "Coupon Code", value: "coupon_code" },
        { text: "Coupon Discount", value: "coupon_discount" },
        { text: "Order Total", value: "order_total" },
        { text: "Customer", value: "customer_name" },
        { text: "Phone", value: "customer_phone" },
      ],
    };
  },
  mounted() {
    this.getData();
    this.loadCoupons();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams({
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          search_keyword: this.filter.search_keyword || "",
        });
        if (this.filter.coupon_id) params.append("coupon_id", this.filter.coupon_id);

        const res = await axios.get(`coupons/usage_report?${params}`);
        this.orders = (res.data.data || []).map((o, i) => ({
          ...o,
          index: (this.page - 1) * this.rowsPerPage + i + 1,
        }));
        this.count = res.data.count || 0;
        this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
    async loadCoupons() {
      try {
        const res = await axios.get("coupons/dropdown");
        this.couponOptions = (res.data.data || []).map((c) => ({
          text: c.code || c.name,
          value: c.id,
        }));
      } catch (e) {
        console.error(e);
      }
    },
    statusColor(status) {
      const map = {
        Delivered: "success",
        Cancelled: "error",
        "Payment Failed": "error",
        Returned: "warning",
        Pending: "grey",
        Shipped: "info",
      };
      return map[status] || "grey";
    },
  },
};
</script>
